import ICompany from 'interfaces/models/company';
import { Observable } from 'rxjs';

import apiService, { ApiService } from './api';

export class CompanyService {
  constructor(private apiService: ApiService) {}

  public get(): Observable<ICompany> {
    return this.apiService.get('/company');
  }

  public save(model: ICompany): Observable<ICompany> {
    return this.apiService.post('/company', model);
  }
}

const companyService = new CompanyService(apiService);
export default companyService;
